import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Logout = () => {
    const [user] = useState(JSON.parse(localStorage.getItem('user')));
    const getLogout = async () => {
        try {
            await axios.get(localStorage.getItem('basurl') + '/logout', { headers: {
                'mojo-access-tokens': user.token
            }}
            ).then(response => {
                localStorage.removeItem("user");
                window.location.href = '/login';
            }).catch(error => {
                console.log(error);
                localStorage.removeItem("user");
                window.location.href = '/login';
            });
        } catch (err) {
            localStorage.removeItem("user");
            window.location.href = '/login';
        }
    }

    useEffect(() => {
        getLogout();
    });

    return (<>
        <div className="d-flex align-items-center justify-content-center bg-br-primary ht-100v">
            <div className="login-wrapper wd-300 wd-xs-350 pd-25 pd-xs-40 bg-white rounded shadow-base">
                <div className="signin-logo tx-center tx-28 tx-bold tx-inverse"><span className="tx-normal">[TV9 MOJO]</span></div>
                <div className="tx-center mg-b-35">Mobile Friendly Solution</div>
                <div>Please wait....</div>
            </div>
        </div>
    </>)
}
export default Logout;